<div class="h-full">
    <div @onOff  *ngFor="let parent of data" class="mt-2">
        <app-node (onNodeClick)="nodeClick($event)" [data]="parent" [mobile]="mobile" [expanded]="expanded"></app-node>
    </div>
</div>